var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"c-footer bg-white d-flex justify-content-between"},[_c('div',[_vm._v("© 2019 - "+_vm._s(_vm.year)+" "),_c('span',[_vm._v("Extraordinary-CBT "+_vm._s(_vm.app_version))])])])}
var staticRenderFns = []

export { render, staticRenderFns }